import { render, staticRenderFns } from "./MessageParent.vue?vue&type=template&id=3a047311&scoped=true"
import script from "./MessageParent.vue?vue&type=script&lang=js"
export * from "./MessageParent.vue?vue&type=script&lang=js"
import style0 from "./MessageParent.vue?vue&type=style&index=0&id=3a047311&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a047311",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a047311')) {
      api.createRecord('3a047311', component.options)
    } else {
      api.reload('3a047311', component.options)
    }
    module.hot.accept("./MessageParent.vue?vue&type=template&id=3a047311&scoped=true", function () {
      api.rerender('3a047311', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parentdiary/MessageParent.vue"
export default component.exports